import { addDays, differenceInMilliseconds } from 'date-fns'

import { ProviderInfo } from '../../models/providers/Providers'
import { PROGRAM_TAXONOMY } from '../common/constants/customerProgram'

const dayInMilliseconds = 60 * 60 * 1000 * 24

export const getRemainingDaysUntil7DayExpiration = ({
  createDateUnixTimestamp,
}: {
  createDateUnixTimestamp?: number
}) => {
  if (!createDateUnixTimestamp) return 7

  // Every favorited provider record expires 7 days after creation
  const expirationDate = addDays(new Date(createDateUnixTimestamp), 7)
  const remainingMs = differenceInMilliseconds(expirationDate, new Date())

  if (remainingMs <= 0) return 0 // already expired

  const remainingDays = remainingMs / dayInMilliseconds

  // If more than 24 hours remaining, round down to nearest day
  // E.g. 3.2 days -> 3, 1.8 days -> 1
  if (remainingDays > 1) return Math.floor(remainingDays)

  // If less than 24 hours remaining, we want to display by hours rather than days.
  // Just return the raw remaining days value, which will be used to calculate hours
  return remainingDays
}

// Converts remaining days to hours -- used when there are less than 24 hours remaining until
// provider expiration. E.g. 0.88 days -> 0.88 * 24 = 21.2 -> 21 hours
export const getRemainingHoursUntil7DayExpiration = ({ remainingDays }: { remainingDays: number }) => {
  return Math.floor(remainingDays * 24)
}

export const isProviderAvailableForBooking = ({ provider }: { provider: ProviderInfo }) => {
  // Check if the provider has the providerCapacity field defined and if so, check if there is capacity for any program
  // DA providers may not have the providerCapacity field defined, but they are still bookable so we check for undefined as well
  const isProviderWithCapacity =
    provider.providerCapacity != undefined && Object.values(provider.providerCapacity).some((value: any) => value >= 1)
  const isDAProvider = provider.program_taxonomy?.some(
    (pt: any) => pt?.partner === PROGRAM_TAXONOMY.partner.directAccess,
  )
  return provider.surfacesWhenAvailable !== false && (isProviderWithCapacity || isDAProvider)
}
